export const emergencyPlanTranslations = {
    en: {
        'EMERGENCY_COMPLETE': 'Complete actions',
        'EP_ACTION_PAGE_MAP': 'Map',
        'EP_ACTION_PAGE_OBJECT': 'Find objects on the map',
        'EP_ACTION_PAGE_LAST_EVENTS': 'Last events',
        'EP_ACTION_PAGE_PEOPLE': 'Find people on the map',
        'EP_ACTION_PAGE_SEND_SIGNALS': 'Send signal',
        'OBJECT_CATEGORY_PERSON': 'Person',
        'OBJECT_CATEGORY_EQUIPMENT': 'Equipment',
    },
    ru: {
        'EMERGENCY_COMPLETE': 'ÐÐ°Ð²ÐµÑÑÐ¸ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ',
        'EP_ACTION_PAGE_MAP': 'ÐÐ°ÑÑÐ°',
        'EP_ACTION_PAGE_OBJECT': 'ÐÐ°Ð¹ÑÐ¸ Ð¾Ð±ÑÐµÐºÑÑ Ð½Ð° ÐºÐ°ÑÑÐµ',
        'EP_ACTION_PAGE_LAST_EVENTS': 'ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¸Ðµ ÑÐ¾Ð±ÑÑÐ¸Ñ',
        'EP_ACTION_PAGE_PEOPLE': 'ÐÐ°Ð¹ÑÐ¸ Ð»ÑÐ´ÐµÐ¹ Ð½Ð° ÐºÐ°ÑÑÐµ',
        'EP_ACTION_PAGE_SEND_SIGNALS': 'ÐÐ¾ÑÐ»Ð°ÑÑ ÑÐ¸Ð³Ð½Ð°Ð»',
        'OBJECT_CATEGORY_PERSON': 'Ð»ÑÐ´Ð¸',
        'OBJECT_CATEGORY_EQUIPMENT': 'Ð¼Ð°ÑÐ¸Ð½Ñ',
    }
};
